<template>
	<ModalComponent
		ref="modalRef"
		:isHeader="false"
		:isFooter="false"
		:is-background-transparent="true"
		:closeOnBackgroundClick="$store.getters.paymentMethod != 'gopay'"
	>
		<div class="review-order bg-grey-10 rounded-lg p-5">
			<div class="flex justify-between items-center order text-white mb-5">
				<div class="text-white text-1.5xl font-bold">
					{{
						$store.getters.paymentMethod == "gopay" && direction == "buy"
							? "Payment Information"
							: "Review Order"
					}}
				</div>
				<!-- <h4 class="modal-title" id="exampleModalLabel" style="color: white">Trade Ticket</h4> -->
			</div>

			<!-- Timer -->
			<div
				v-if="$store.getters.paymentMethod == 'gopay' && direction == 'buy'"
				class="bg-white-2 rounded-md text-black text-xs font-semibold mb-5 py-2 px-5"
			>
				Complete Your Payment Within {{ timerGopayShown }}
			</div>

			<!-- Order Information -->
			<div class="bg-grey-12 rounded-xl text-white text-xs mb-5 p-5">
				<div class="font-semibold mb-4">Order Information</div>

				<div class="flex items-center mb-2">
					<div class="grow">Order Direction</div>
					<div :class="`ga-review-order-dir-${direction} capitalize`">
						{{ direction }}
					</div>
				</div>

				<div class="flex items-center mb-2">
					<div class="grow">Order Type</div>
					<div
						:class="`ga-review-order-type-${orderType.toLowerCase()} capitalize`"
					>
						{{ orderType }}
					</div>
				</div>

				<div v-if="orderType == 'limit'" class="flex items-center mb-2">
					<div class="grow">Valid Until</div>
					<div class="capitalize">{{ validUntil }}</div>
				</div>

				<div class="flex items-center mb-2">
					<div class="grow">Contract</div>
					<div>{{ contractConfigs.name }}</div>
				</div>

				<div class="flex items-center mb-2">
					<div class="grow">Price per Gram</div>
					<div>{{ currencySymbol }} {{ pricePerGramShown }}</div>
				</div>

				<div class="flex items-center mb-2">
					<div class="grow">Contract Price</div>
					<div>{{ currencySymbol }} {{ contractPriceShown }}</div>
				</div>

				<div class="flex items-center mb-2">
					<div class="grow">Quantity</div>
					<div>
						{{ totalQuantity }}
					</div>
				</div>

				<div class="flex items-center">
					<div class="grow">Total Gram</div>
					<div>{{ totalGram }} g</div>
				</div>
			</div>

			<!-- Order Details -->
			<div class="bg-grey-12 rounded-xl text-white text-xs mb-2 p-5">
				<div class="font-semibold mb-4">
					Estimated Order Details <TooltipRincianOrder :direction="direction" />
				</div>

				<div class="flex items-center mb-2">
					<div class="grow">Contract Value</div>
					<div>{{ currencySymbol }} {{ contractValueShown }}</div>
				</div>

				<div class="flex items-center mb-2">
					<div class="grow">Fee</div>
					<div>{{ minusSign }} {{ currencySymbol }} {{ feeShown }}</div>
				</div>

				<div class="flex items-center mb-2">
					<div class="grow">Tax</div>
					<div>{{ minusSign }} {{ currencySymbol }} {{ taxShown }}</div>
				</div>

				<div
					v-if="$store.getters.paymentMethod == 'gopay'"
					class="flex items-center mb-2"
				>
					<div class="grow">Buffer Fee</div>
					<div>{{ minusSign }} {{ currencySymbol }} {{ fxBufferShown }}</div>
				</div>

				<div
					class="flex items-center"
					:class="`${
						direction == 'sell' ? '' : 'text-sm font-semibold text-gold'
					}`"
				>
					<div class="grow">
						{{ direction == "sell" ? "Total Sell Order" : "Total Buy Order" }}
					</div>
					<div>{{ currencySymbol }} {{ totalDirOrderShown }}</div>
				</div>

				<div v-if="direction == 'sell'" class="mt-4">
					<div class="flex items-center mb-2">
						<div class="grow">Storage Fee</div>
						<div>{{ currencySymbol }} {{ storageFeeShown }}</div>
					</div>

					<div class="flex items-center text-gold">
						<div class="grow">Est. Amount Received</div>
						<div>{{ currencySymbol }} {{ finalAmountShown }}</div>
					</div>
				</div>
			</div>

			<div
				v-if="direction == 'buy'"
				class="bg-grey-12 rounded-xl text-white text-xs mb-5 p-5"
			>
				<div
					v-if="$store.getters.paymentMethod == 'rped'"
					class="flex items-center mb-2"
				>
					<div class="grow">FX Buffer</div>
					<div>{{ minusSign }} {{ currencySymbol }} {{ fxBufferShown }}</div>
				</div>

				<div
					v-if="$store.getters.paymentMethod == 'gopay'"
					class="flex items-center mb-2"
				>
					<div class="grow">Biaya Admin</div>
					<div>{{ minusSign }} {{ currencySymbol }} {{ adminFeeShown }}</div>
				</div>

				<div class="flex items-center">
					<div class="grow">
						Total Est. Maximum Payment
						<TooltipEstimateMaximumPayment v-if="direction == 'buy'" />
					</div>
					<div>{{ currencySymbol }} {{ finalAmountShown }}</div>
				</div>
			</div>

			<!-- Instant ROG -->
			<div
				v-if="
					$store.getters.paymentMethod == 'rped' &&
					$parent.$parent.isEventRogActive &&
					direction == 'buy'
				"
				class="bg-grey-12 rounded-xl text-white text-xs mb-5 p-5"
			>
				<InstantROG :orderDetailsIdr="$parent.$parent.tradeTicketDataIdr" />
			</div>

			<div
				v-if="direction == 'sell'"
				class="flex justify-start item-start text-white text-xs mb-5"
			>
				<input
					type="checkbox"
					class="cursor-hover-pointer h-min mr-2"
					v-model="disclaimerCheck"
				/>
				<div class="text-xs ml-1">
					I understand and agree to the procedures and terms for the matching,
					settlement, and fund disbursement of sell transactions in the
					commodity exchange market.
					<br />
					<span class="text-theme cursor-pointer" @click="showDisclaimer()"
						>Learn More</span
					>
				</div>
			</div>

			<!-- Buttons -->
			<div class="">
				<div
					v-if="this.$store.state.marketInquiryStatus == 'loading'"
					class="col-12 text-center"
				>
					<Loader size_prop="3em"> </Loader>
				</div>
				<template v-if="this.$store.state.marketInquiryStatus != 'loading'">
					<!-- <button type="button" class="col btn c-btn-danger mr-3 px-0" @click="closeReviewOrder()">{{closeButtonText}}</button> -->
					<!-- <button type="button" class="col btn c-btn-warning px-0" @click="submitOrder()" :disabled="submitButtonDisabled">SUBMIT ORDER</button> -->

					<div
						v-if="$store.getters.paymentMethod == 'gopay' && direction == 'buy'"
						class="flex flex-col"
					>
						<button
							type="button"
							class="ga-submit-order w-full btn c-btn-theme text-xs mb-3"
							:disabled="direction == 'sell' && !disclaimerCheck"
							@click="submitOrder()"
						>
							PAY NOW
						</button>
						<button
							type="button"
							class="ga-cancel-order w-full btn bg-grey-12 text-red text-xs mb-2"
							@click="closeReviewOrder()"
						>
							CANCEL ORDER
						</button>
					</div>

					<div v-else>
						<button
							type="button"
							class="ga-submit-order w-full btn c-btn-theme rounded-md mb-3"
							:disabled="direction == 'sell' && !disclaimerCheck"
							@click="submitOrder()"
						>
							SUBMIT ORDER
						</button>
						<button
							type="button"
							class="ga-cancel-order w-full btn bg-grey-12 rounded-md text-red"
							@click="closeReviewOrder()"
						>
							CANCEL
						</button>
					</div>
				</template>
			</div>

			<div v-if="false">
				<div class="">
					<hr class="border border-transparent border-grey-1 mt-0 mb-3" />
				</div>

				<div class="p-5">
					<div
						v-if="$store.getters.paymentMethod == 'gopay' && direction == 'buy'"
						class="bg-white text-black text-xs rounded py-2 px-5 mb-2"
					>
						Selesaikan Pembayaran dalam {{ timerGopayShown }}
					</div>

					<div class="rounded text-white text-xs bg-grey-2 pb-2 mb-5">
						<div class="p-5 pb-0 mb-3">
							<!-- Market -->
							<div v-if="orderType == 'market'" class="">
								<div class="mb-2">
									<span class="text-left">Order Direction</span>
									<div
										:class="`text-right float-right ${
											direction == 'buy' ? 'text-green' : 'text-red '
										} number-font font-weight-bold`"
									>
										{{ direction == "buy" ? "Beli" : "Jual" }}
									</div>
								</div>

								<div v-if="$store.getters.paymentMethod == 'rped'" class="mb-2">
									<span class="text-left">Order Type</span>
									<div
										class="text-capitalize text-right float-right text-white number-font"
									>
										{{ orderType }}
									</div>
								</div>

								<div class="mb-2">
									<span class="text-left">Price Per Gram</span>
									<div class="text-right float-right text-white number-font">
										{{ currencySymbol + " " + pricePerGramShown }}
									</div>
								</div>
								<div class="mb-2">
									<span class="text-left">Contract Price</span>
									<div class="text-right float-right text-white number-font">
										{{ currencySymbol + " " + contractPriceShown }}
									</div>
								</div>
								<div class="mb-2">
									<span class="text-left">Kuantitas</span>
									<div class="text-right float-right text-white number-font">
										{{ totalQuantity }}
									</div>
								</div>
								<div class="mb-3">
									<span class="text-left">Total Gram</span>
									<div class="text-right float-right text-white number-font">
										{{ totalGram }}
									</div>
								</div>

								<hr
									class="border border-transparent border-grey-1 mt-0 mb-3 mx--5"
								/>

								<div class="font-medium mb-2">
									<span class="mr-1">Rincian Order</span>
									<TooltipRincianOrder :direction="direction" />
								</div>

								<div class="mb-2">
									<span class="text-left">Contract Value</span>
									<div class="text-right float-right text-white number-font">
										{{ currencySymbol }} {{ contractValueShown }}
									</div>
								</div>
								<div class="mb-2">
									<span class="text-left">Fee</span>
									<div class="text-right float-right text-white number-font">
										{{ minusSign }} {{ currencySymbol }} {{ feeShown }}
									</div>
								</div>
								<div class="mb-2">
									<span class="text-left">Tax</span>
									<div class="text-right float-right text-white number-font">
										{{ minusSign }} {{ currencySymbol }} {{ taxShown }}
									</div>
								</div>

								<div
									v-if="$store.getters.paymentMethod == 'gopay'"
									class="mb-3"
								>
									<span class="text-left position-relative">
										{{
											direction == "buy"
												? "Total Sell Order"
												: "Total Buy Order"
										}}
									</span>

									<div class="text-right float-right text-white number-font">
										{{ currencySymbol }} {{ totalTypeAShown }}
									</div>
								</div>

								<hr
									v-if="$store.getters.paymentMethod == 'gopay'"
									class="border border-transparent border-grey-1 m-0 mb-3"
								/>

								<div
									v-if="$store.getters.paymentMethod == 'gopay'"
									class="mb-3"
								>
									<span class="text-left position-relative">
										Biaya Admin <span class=""></span>
									</span>

									<div class="text-right float-right text-white number-font">
										{{ minusSign }} {{ currencySymbol }} {{ adminFeeShown }}
									</div>
								</div>

								<hr class="border border-transparent border-grey-1 mt-0 mb-3" />

								<div v-if="direction == 'sell'" class="mb-2">
									<span class="text-left">Storage Fee</span>
									<div class="text-right float-right text-white number-font">
										{{ currencySymbol }} {{ storageFeeShown }}
									</div>
								</div>

								<div v-if="direction == 'buy'" class="mb-2">
									<span class="text-left">FX Buffer</span>
									<div class="text-right float-right text-white number-font">
										Rp {{ fxBufferShown }}
									</div>
								</div>

								<div class="fw-600 mt-2 text-gold">
									<span class="text-left">
										{{
											direction == "sell"
												? "Estimasi Diterima"
												: "Total Est. Maximum Payment"
										}}
									</span>

									<template v-if="currency == 'idr'">
										<div class="text-right float-right number-font">
											Rp {{ finalAmountIdrShown }}
										</div>
									</template>

									<template v-else>
										<div class="text-right float-right number-font">
											$ {{ finalAmountUsdShown }}
										</div>
									</template>
								</div>
							</div>

							<!-- Limit -->
							<div v-if="orderType == 'limit'" class="">
								<div class="mb-2">
									<span class="text-left">Order Direction</span>
									<div
										:class="`text-right float-right ${
											direction == 'buy' ? 'color-green-c ' : 'color-red-c '
										} number-font text-uppercase font-weight-bold`"
									>
										{{ direction }}
									</div>
								</div>

								<div class="mb-2">
									<span class="text-left">Order Type</span>
									<div
										class="text-capitalize text-right float-right text-white number-font"
									>
										{{ orderType }}
									</div>
								</div>

								<div class="mb-2">
									<span class="text-left">Valid Until</span>
									<div
										class="text-right float-right text-white number-font text-capitalize"
									>
										{{ validUntil }}
									</div>
								</div>

								<div class="mb-2">
									<span class="text-left">Price Per Gram</span>
									<div class="text-right float-right text-white number-font">
										{{ currencySymbol }} {{ pricePerGramLimitShown }}
									</div>
								</div>

								<div class="mb-2">
									<span class="text-left">Contract Price</span>
									<div class="text-right float-right text-white number-font">
										{{ currencySymbol }} {{ contractPriceShown }}
									</div>
								</div>

								<div class="mb-2">
									<span class="text-left">Kuantitas</span>
									<div class="text-right float-right text-white number-font">
										{{ totalQuantity }}
									</div>
								</div>

								<div class="mb-5">
									<span class="text-left">Total Gram</span>
									<div class="text-right float-right text-white number-font">
										{{ totalGram }}
									</div>
								</div>

								<hr
									class="border border-transparent border-grey-1 mt-0 mb-3 mx--5"
								/>

								<div class="font-medium mb-2">
									<span class="mr-1">Rincian Order</span>
									<TooltipRincianOrder :direction="direction" />
								</div>

								<div class="mb-2">
									<span class="text-left">Contract Value</span>
									<div class="text-right float-right text-white number-font">
										{{ currencySymbol }} {{ contractValueShown }}
									</div>
								</div>
								<div class="mb-2">
									<span class="text-left">Fee</span>
									<div class="text-right float-right text-white number-font">
										{{ minusSign }} {{ currencySymbol }} {{ feeShown }}
									</div>
								</div>
								<div class="">
									<span class="text-left">Tax</span>
									<div class="text-right float-right text-white number-font">
										{{ minusSign }} {{ currencySymbol }} {{ taxShown }}
									</div>
								</div>

								<div class="fw-600 mt-2 mb-3">
									<span class="text-left">
										{{
											direction == "sell"
												? "Total Sell Order"
												: "Total Buy Order"
										}}
									</span>

									<div class="text-right float-right number-font">
										{{ currencySymbol }} {{ totalTypeAShown }}
									</div>
								</div>

								<hr class="border border-transparent border-grey-1 mt-0 mb-3" />

								<div v-if="direction == 'sell'" class="mt-2">
									<span class="text-left">Estimate Storage Fee</span>
									<div class="text-right float-right text-white number-font">
										{{ currencySymbol }} 0
									</div>
								</div>
								<div v-if="direction == 'buy'" class="mt-2">
									<span class="text-left">FX Buffer</span>
									<div class="text-right float-right text-white number-font">
										Rp {{ fxBufferShown }}
									</div>
								</div>

								<div class="fw-600 mt-2 text-gold">
									<span class="text-left">
										{{
											direction == "sell"
												? "Estimasi Diterima"
												: "Total Est. Maximum Payment"
										}}
									</span>

									<template v-if="currency == 'idr'">
										<div class="text-right float-right number-font">
											Rp {{ finalAmountIdrShown }}
										</div>
									</template>

									<template v-else>
										<div class="text-right float-right number-font">
											$ {{ finalAmountUsdShown }}
										</div>
									</template>
								</div>
							</div>
						</div>

						<div v-if="direction == 'sell'" class="bg-grey-1 rounded mx-2 p-3">
							<span class="text-left position-relative"> Estimasi Profit </span>
							<div
								class="text-right float-right number-font"
								:class="`${
									estimasiProfitShown.includes('-')
										? 'text-danger'
										: estimasiProfitShown.includes('+')
										? 'text-success'
										: 'text-white'
								}`"
							>
								{{ estimasiProfitShown }}
							</div>
						</div>

						<Cashback
							v-if="
								$store.getters.paymentMethod == 'rped' &&
								$parent.$parent.isEventRogActive &&
								direction == 'buy'
							"
							class="mx-5 mb-4"
							:contractValue="
								currency == 'idr'
									? reviewOrderData_prop.contractValueIdr
									: reviewOrderData_prop.contractValueUsd
							"
						/>
					</div>

					<!-- disclaimer for SELL -->
					<div v-if="direction == 'sell'" class="mb-5">
						<div class="flex justify-start item-start text-white">
							<input
								type="checkbox"
								class="cursor-hover-pointer h-min mr-2"
								v-model="disclaimerCheck"
							/>
							<div class="text-xs ml-1">
								Saya memahami dan menyetujui prosedur serta ketentuan proses
								penyepadanan, penyelesaian & pencairan dana transaksi jual
								sistem pasar Bursa Komoditi
								<br />
								<span
									class="text-theme cursor-pointer"
									@click="showDisclaimer()"
									>Learn More</span
								>
							</div>
						</div>
					</div>

					<div
						v-if="$store.getters.paymentMethod == 'gopay' && direction == 'buy'"
						class="text-grey text-xs mb-5"
					>
						Klik Pay Now untuk melanjutkan proses dan beralih ke halaman payment
						gateway untuk menyelesaikan pembayaran
					</div>
				</div>
			</div>
		</div>
	</ModalComponent>
</template>

<script>
	import { Decimal } from "decimal.js"

	import Utils from "../utils"

	import Loader from "@/components/Loader.vue"
	import Alert from "./alert-component/AlertComponent"

	import Tooltip from "@/components/Tooltip.vue"
	import ModalComponent from "./ModalComponent.vue"
	import TooltipRincianOrder from "./tradeticket/TooltipRincianOrder.vue"
	import Cashback from "./Cashback.vue"
	import InstantROG from "./tradeticket/InstantROG.vue"
	import TooltipEstimateMaximumPayment from "./tradeticket/TooltipEstimateMaximumPayment.vue"

	export default {
		name: "ReviewOrder",

		props: {
			reviewOrderData_prop: {
				type: Object,
				default: () => {
					return {}
				},
			},
		},

		components: {
			Loader,
			Tooltip,
			ModalComponent,
			TooltipRincianOrder,
			Cashback,
			InstantROG,
			TooltipEstimateMaximumPayment,
		},

		data() {
			return {
				publicPath: process.env.BASE_URL,
				colorGrey8: getComputedStyle(document.documentElement).getPropertyValue(
					"--color-grey8",
				),

				formControl: false,
				formControlPlaintext: true,
				originalQuantity: 0,
				originalContractPrice: 0,
				quantityEdit: 1,
				contractPriceEdit: 0,
				displayFormLimit: "none",
				displayFormMarket: "flex",
				varia: true,
				submitButtonDisabled: true,
				setIntervalData: "",
				disclaimerCheck: false,

				timerGopay: null,
				timerGopayShown: "15:00",
				setIntervalTimerGopay: null,

				isGopayPaymentPageOpened: false,
			}
		},
		computed: {
			account() {
				return ""
			},
			hin() {
				return this.$store.getters.getHin
			},

			currency() {
				return this.$store.state.currency
			},
			currencySymbol() {
				return this.currency == "idr" ? "Rp" : "$"
			},

			modalClass() {
				return {
					modalDialog: true,
					"modal-open": true,
				}
			},
			inputClass() {
				return {
					"form-control": this.formControl,
					"form-control-plaintext": this.formControlPlaintext,
					"form-control-sm": true,
					"px-2": true,
				}
			},

			contractConfigs() {
				return this.$store.getters.getContractConfigs(
					this.reviewOrderData_prop.contractId,
				)
			},

			contractPrice() {
				let contractPrice
				if (
					this.$store.getters.paymentMethod == "gopay" &&
					this.direction == "buy"
				) {
					contractPrice =
						this.currency == "idr"
							? this.reviewOrderData_prop.contractPriceIdr
							: this.reviewOrderData_prop.contractPriceUsd
				} else {
					contractPrice =
						this.currency == "idr"
							? this.$parent.$parent.contractPriceIdr
							: this.$parent.$parent.contractPriceUsd
				}

				return contractPrice
			},

			contractPriceShown() {
				const contractPrice = this.contractPrice

				return Utils.currencyFormat(contractPrice)
			},

			direction() {
				return this.reviewOrderData_prop.direction
			},
			orderType() {
				return this.reviewOrderData_prop.orderType || ""
			},
			validUntil() {
				return this.reviewOrderData_prop.validUntil
			},

			pricePerGramShown() {
				if (
					this.$store.getters.paymentMethod == "gopay" &&
					this.direction == "buy"
				) {
					if (this.currency == "usd") {
						return Utils.currencyFormat(
							this.reviewOrderData_prop.pricePerGramUsd,
						)
					} else {
						return Utils.currencyFormat(
							this.reviewOrderData_prop.pricePerGramIdr,
						)
					}
				}

				const pricePerGram =
					this.currency == "idr"
						? this.$parent.$parent.pricePerGramIdr
						: this.$parent.$parent.pricePerGramUsd

				return Utils.currencyFormat(pricePerGram)
			},

			priceGramLimit() {
				return this.reviewOrderData_prop.priceGram
			},

			pricePerGramLimitShown() {
				let price = this.priceGramLimit
				let streamingRate = this.streamingRate.streamBuy
				if (this.direction == "sell") {
					streamingRate = this.streamingRate.streamSell
				}

				if (price == "-") {
					return "-"
				} else {
					if (this.currency == "usd") {
						return Utils.currencyFormat(
							new Decimal(price).toFixed(this.$store.state.fractionDigit.usd),
						)
					} else {
						return Utils.currencyFormat(
							Decimal.mul(price, streamingRate).toFixed(
								this.$store.state.fractionDigit.idr,
							),
						)
					}
				}
			},

			displayEdit() {
				return this.orderType == "limit" ? "initial" : "none"
			},
			displayKill() {
				return "initial"
			},
			// submitButtonDisabled(){
			// 	let status = true
			// 	if (this.$store.state.marketInquiryStatus == 'success') {
			// 		status = false
			// 	}
			// 	return status
			// },
			closeButtonText() {
				if (this.submitButtonDisabled) {
					return "ORDER AGAIN"
				} else if (this.$store.state.marketInquiryStatus == "loading") {
					return "CHANGE"
				} else {
					return "CHANGE"
				}
			},

			// QWEQWEQWEQWEQWEQWEQWE
			streamingRate() {
				return this.$store.getters.getStreamingRate
			},

			totalGram() {
				return this.reviewOrderData_prop.gram
			},

			totalQuantity() {
				if (this.currency == "usd") {
					return this.reviewOrderData_prop.quantity
				}
				return this.reviewOrderData_prop.quantity
			},

			contractValueShown() {
				if (
					this.$store.getters.paymentMethod == "gopay" &&
					this.direction == "buy"
				) {
					if (this.currency == "idr") {
						return Utils.currencyFormat(
							this.reviewOrderData_prop.contractValueIdr,
						)
					} else {
						return Utils.currencyFormat(
							this.reviewOrderData_prop.contractValueUsd,
						)
					}
				} else {
					return this.$parent.$parent.valueShown
				}
			},

			minusSign() {
				const contractValue =
					this.currency == "idr"
						? this.reviewOrderData_prop.contractValueIdr
						: this.reviewOrderData_prop.contractValueUsd
				if (this.direction == "buy" || contractValue == 0) {
					return ""
				} else {
					return "-"
				}
			},

			feeShown() {
				if (
					this.$store.getters.paymentMethod == "gopay" &&
					this.direction == "buy"
				) {
					if (this.currency == "idr") {
						return Utils.currencyFormat(this.reviewOrderData_prop.feeIdr, "idr")
					} else {
						return Utils.currencyFormat(this.reviewOrderData_prop.feeUsd, "usd")
					}
				} else {
					return this.$parent.$parent.feeShown
				}
			},

			taxShown() {
				if (
					this.$store.getters.paymentMethod == "gopay" &&
					this.direction == "buy"
				) {
					if (this.currency == "idr") {
						return Utils.currencyFormat(this.reviewOrderData_prop.taxIdr, "idr")
					} else {
						return Utils.currencyFormat(this.reviewOrderData_prop.taxUsd, "usd")
					}
				} else {
					return this.$parent.$parent.taxShown
				}
			},

			// Total with Contract Value, Fee, and Tax
			totalTypeAShown() {
				if (
					this.$store.getters.paymentMethod == "gopay" &&
					this.direction == "buy"
				) {
					if (this.currency == "idr") {
						return Utils.currencyFormat(
							this.reviewOrderData_prop.totalTypeAIdr,
							"idr",
						)
					} else {
						return Utils.currencyFormat(
							this.reviewOrderData_prop.totalTypeAUsd,
							"usd",
						)
					}
				} else {
					return this.$parent.$parent.totalTypeAShown
				}
			},

			storageFeeShown() {
				if (
					this.$store.getters.paymentMethod == "gopay" &&
					this.direction == "buy"
				) {
					if (this.currency == "idr") {
						return Utils.currencyFormat(
							this.reviewOrderData_prop.storageFeeIdr,
							"idr",
						)
					} else {
						return Utils.currencyFormat(
							this.reviewOrderData_prop.storageFeeUsd,
							"usd",
						)
					}
				} else {
					return this.$parent.$parent.storageFeeShown
				}
			},

			fxBufferShown() {
				if (
					this.$store.getters.paymentMethod == "gopay" &&
					this.direction == "buy"
				) {
					if (this.currency == "idr") {
						return Utils.currencyFormat(this.reviewOrderData_prop.fxBufferIdr)
					} else {
						return Utils.currencyFormat(this.reviewOrderData_prop.fxBufferUsd)
					}
				} else {
					return this.$parent.$parent.fxBufferShown
				}
			},

			totalUsdShown() {
				if (
					this.$store.getters.paymentMethod == "gopay" &&
					this.direction == "buy"
				) {
					return Utils.currencyFormat(this.reviewOrderData_prop.totalUsd, "usd")
				} else {
					return this.$parent.$parent.totalUsdShown
				}
			},

			totalIdrShown() {
				if (
					this.$store.getters.paymentMethod == "gopay" &&
					this.direction == "buy"
				) {
					return Utils.currencyFormat(this.reviewOrderData_prop.totalIdr, "idr")
				} else {
					return this.$parent.$parent.totalIdrShown
				}
			},

			// gopay
			adminFeeShown() {
				if (
					this.$store.getters.paymentMethod == "gopay" &&
					this.direction == "buy"
				) {
					if (this.currency == "idr") {
						return Utils.currencyFormat(
							this.reviewOrderData_prop.adminFeeIdr,
							"idr",
						)
					} else {
						return Utils.currencyFormat(
							this.reviewOrderData_prop.adminFeeUsd,
							"usd",
						)
					}
				} else {
					return this.$parent.$parent.adminFeeShown
				}
			},

			totalDirOrderShown() {
				if (
					this.$store.getters.paymentMethod == "gopay" &&
					this.direction == "buy"
				) {
					if (this.currency == "idr") {
						return Utils.currencyFormat(
							this.reviewOrderData_prop.totalIdr,
							"idr",
						)
					} else {
						return Utils.currencyFormat(
							this.reviewOrderData_prop.totalUsd,
							"usd",
						)
					}
				} else {
					return this.$parent.$parent.totalTypeAShown
				}
			},

			finalAmountIdrShown() {
				if (
					this.$store.getters.paymentMethod == "gopay" &&
					this.direction == "buy"
				) {
					return Utils.currencyFormat(
						this.reviewOrderData_prop.finalAmountIdr,
						"idr",
					)
				} else {
					return this.$parent.$parent.finalAmountIdrShown
				}
			},

			finalAmountUsdShown() {
				if (
					this.$store.getters.paymentMethod == "gopay" &&
					this.direction == "buy"
				) {
					return Utils.currencyFormat(
						this.reviewOrderData_prop.finalAmountUsd,
						"usd",
					)
				} else {
					return this.$parent.$parent.finalAmountUsdShown
				}
			},

			finalAmountShown() {
				if (this.currency == "idr") {
					return this.finalAmountIdrShown
				} else {
					return this.finalAmountUsdShown
				}
			},

			estimasiProfitShown() {
				if (
					this.$store.getters.paymentMethod == "gopay" &&
					this.direction == "buy"
				) {
					return this.reviewOrderData_prop.estimasiProfitShown
				} else {
					return this.$parent.$parent.estimasiProfitShown
				}
			},
		},
		watch: {
			orderType(newValue) {
				if (newValue == "market") {
					this.displayFormLimit = "none"
					this.submitButtonDisabled = true
				} else {
					this.displayFormLimit = "flex"
					this.submitButtonDisabled = false
				}
			},
		},
		created() {},
		beforeUpdate() {},

		methods: {
			openReviewOrder() {
				this.$refs.modalRef.openModal()

				if (
					this.$store.getters.paymentMethod == "gopay" &&
					this.direction == "buy"
				) {
					window.onbeforeunload = () => {
						return "Jika Anda membatalkan proses ini, order tidak dapat dilanjutkan. <br> Catatan: Status order mungkin masih tertulis Waiting for Payment dan akan diperbarui secara otomatis setelah beberapa saat."
					}
				}
			},

			closeReviewOrder() {
				window.onbeforeunload = null
				if (
					this.$store.getters.paymentMethod == "gopay" &&
					this.direction == "buy"
				) {
					Alert.open({
						type: "confirm",
						title: "Apakah Anda yakin ingin membatalkan order?",
						showIcon: false,
						description:
							"Jika Anda membatalkan proses ini, order tidak dapat dilanjutkan. <br> Catatan: Status order mungkin masih tertulis Waiting for Payment dan akan diperbarui secara otomatis setelah beberapa saat.",
						buttonConfirmText: "Ya, Batalkan Order",
						buttonDeclineText: "Tutup",
						onConfirm: () => {
							this.disclaimerCheck = false

							this.resetTimerGopay()

							this.$refs.modalRef.closeModal()
						},
					})
				} else {
					this.disclaimerCheck = false

					this.resetTimerGopay()

					this.$refs.modalRef.closeModal()
				}
			},
			// numberFormatExtend(value, nn = 5, xx = 3, ss = ',', cc = '.') {
			// 	Number.prototype.format = function(n, x, s, c) {
			//     let re = '\\d(?=(\\d{' + (x || 3) + '})+' + (n > 0 ? '\\D' : '$') + ')',
			//       num = String(this);

			//     return (c ? num.replace('.', c) : num).replace(new RegExp(re, 'g'), '$&' + (s || ','));
			// 	}

			// 	return value.format(nn, xx, ss, cc)
			// },

			showDisclaimer() {
				Alert.open({
					// type: 'confirm',
					title: " ",
					description: " ",
					showIcon: false,
					showSellWarning: true,
					buttonCloseText: "OK",
					onConfirm: () => {},
				})
			},

			submitOrder() {
				if (
					this.$store.getters.paymentMethod == "gopay" &&
					this.direction == "buy"
				) {
					this.isGopayPaymentPageOpened = true
					this.$emit("submitGopay")
				} else {
					this.$emit("submit")
				}
			},
			// closeReviewOrder() {
			// 	if (this.$store.state.marketInquiryStatus == 'success' || this.$store.state.marketInquiryStatus == 'loading') {
			// 		clearInterval(this.setIntervalData)
			// 		document.getElementById("progressBar").style.width = 100 + "%"
			// 		document.getElementById("frontBar").innerHTML = '10.0s'
			// 		this.$store.commit('STOP_TIMER')
			// 	}
			// 	this.$emit('close')
			// }

			startTimerGopay() {
				// 15 minutes countdown. Format: 00:15:00
				this.setIntervalTimerGopay = setInterval(() => {
					if (this.timerGopay == null) {
						this.timerGopay = new Date().getTime() + 900000
					}

					const now = new Date().getTime()
					const distance = this.timerGopay - now
					const minutes = Math.floor(
						(distance % (1000 * 60 * 60)) / (1000 * 60),
					)
					const seconds = Math.floor((distance % (1000 * 60)) / 1000)

					this.timerGopayShown = `${minutes}:${
						seconds < 10 ? "0" + seconds : seconds
					}`

					if (distance < 0) {
						if (!this.isGopayPaymentPageOpened) {
							Alert.open({
								type: "warning",
								title: "Waktu Pembayaran Habis",
								description: "Silahkan lakukan order kembali.",
								buttonCloseText: "OK",
								onClose: () => {
									this.resetTimerGopay()

									this.disclaimerCheck = false

									this.$refs.modalRef.closeModal()
								},
							})
						}

						this.resetTimerGopay()
					}
				}, 1000)
			},

			resetTimerGopay() {
				clearInterval(this.setIntervalTimerGopay)
				this.timerGopay = null
				this.timerGopayShown = "15:00"
			},
		},
	}
</script>

<style scoped>
	.review-order {
		/* 480px */
		width: 30rem;
		max-width: calc(100% - 2.5rem);
	}

	.modalDialog {
		position: fixed;
		font-family: Arial, Helvetica, sans-serif;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
		overflow-y: scroll;
		background: rgba(0, 0, 0, 0.8);
		z-index: 9999;
		opacity: 0;
		-webkit-transition: opacity 400ms ease-in;
		-moz-transition: opacity 400ms ease-in;
		transition: opacity 400ms ease-in;
		pointer-events: none;
	}

	.modalDialog:target {
		opacity: 1;
		pointer-events: auto;
	}

	.modal-open {
		opacity: 1;
		pointer-events: auto;
		margin: 0px 12px;
	}

	.modalDialog > div {
		max-width: 400px;
		position: relative;

		margin-top: 60px;
		margin-right: auto;
		margin-left: auto;

		padding: 2em;
		border-radius: 10px;
		background: #191f31;
		background: -moz-linear-gradient(#fff, #999);
		background: -webkit-linear-gradient(#fff, #999);
		background: -o-linear-gradient(#fff, #999);
	}

	.close {
		background: #606061;
		color: #ffffff;
		line-height: 25px;
		position: absolute;
		right: -12px;
		text-align: center;
		top: -10px;
		width: 24px;
		text-decoration: none;
		font-weight: bold;
		-webkit-border-radius: 12px;
		-moz-border-radius: 12px;
		border-radius: 12px;
		-moz-box-shadow: 1px 1px 3px #000;
		-webkit-box-shadow: 1px 1px 3px #000;
		box-shadow: 1px 1px 3px #000;
	}

	.close:hover {
		background: #00d9ff;
	}

	.c-prepend-button:hover {
		cursor: pointer;
	}

	.c-append-button:hover {
		cursor: pointer;
	}

	.form-control-plaintext {
		padding: 0px 1px 3px 1px;
	}

	#myProgress {
		position: relative;
		width: 100%;
		height: 30px;
		background-color: #c4c4c4;
		border-radius: 100px;
		overflow: hidden;
	}

	#myBar {
		margin: 0;
		position: absolute;
		top: 50%;
		-ms-transform: translateY(-50%);
		transform: translateY(-50%) scale(0.97, 1);

		width: 100%;
		height: 19px;
		background-color: transparent;
		text-align: center;
		color: white;
		border-radius: 100px;
		overflow: hidden;
	}

	#progressBar {
		width: 100%;
		height: 19px;
		background-color: #f0981c;
		/*border-radius: 100px;*/
	}

	#frontBar {
		position: absolute;
		top: 0;
		color: black;
		background-color: transparent;
		width: 100%;
		text-align: center;
		line-height: 30px;
		font-size: 14px;
		font-weight: bold;
	}

	.value-field {
		background-color: transparent;
		color: rgba(255, 255, 255, 0.5);
	}

	.total-value {
		color: gold;
		font-size: 16px;
	}

	.total-value.total-value-idr {
		line-height: 16px;
	}

	input[type="checkbox"] {
		-webkit-appearance: checkbox;
	}
</style>
